import { Icon, Tooltip } from '@scality/core-ui';
import type React from 'react';
import { SelectClearButton } from './Select.styles';

export type SelectChipClearButtonProps = {
  /** Used for tooltip, `aria-label`, and screen reader name (keep in sync). */
  label: string;
  onClear: () => void;
};

export const SelectChipClearButton: React.FC<SelectChipClearButtonProps> = ({ label, onClear }) => (
  <Tooltip overlay={label}>
    <SelectClearButton
      type="button"
      aria-label={label}
      onClick={(e) => {
        e.stopPropagation();
        onClear();
      }}
    >
      <Icon name="Close" size="xs" />
    </SelectClearButton>
  </Tooltip>
);
